import AddButton from 'lib/components/add-button/AddButton';
import EditButton from 'lib/components/edit-button/EditButton';
import LinkableResourcesModal from 'lib/components/linkable-resources-modal/LinkableResourcesModal';
import DefectsModal from '../../../../lib/components/defects-modal/DefectsModal';
import QuestionsModal from 'lib/components/questions-modal/QuestionsModal';
import QuestionGroupsModal from '../question-groups-modal/QuestionGroupsModal';
import MoveQuestionPositionModal from 'lib/components/move-question-position-modal/MoveQuestionPositionModal';

import useInspectionPlansFormNew from '../../useInspectionPlansFormNew';

import './InspectionPlansForm.scss';
import InspectionPlansFormNewGroups from './InspectionPlansFormNewGroups';
import InspectionPlansFormNewPlan from './InspectionPlansFormNewPlan';
import ErrorBag from 'lib/components/error-bag/ErrorBag';

// TODO: Rewrites left:
// ----- fetchOnHoldInspectionCount
// ----- prepareStateForValidation
// ----- uploadQuestionDocuments
// ----- userSubmitsForm
// ----- isResourceDisabled
// TODO: What's left:
// ----- Validation retouch
// ----- Show global errors
// ----- Show server errors
// ----- Translate form to API object
// ----- Actual submission to API
// ----- Upload docs
// ----- Loader handling
//
// TODO: Long run refactor:
// ----- Completely separate error state from data object
// ----- Separate data from form presentation - {value,label} pairs
//       should only exist around their presentation components
// ----- Cast all data to API-ready model so we can completely
//       remove the toForm, toDetail, toPOST data transforms
// ----- Use local state to handle question-level and group-level changes and memoize components

const InspectionPlansFormNew = (props) => {
  const vm = useInspectionPlansFormNew({
    id: props.match?.params?.id,
  });

  const moveQuestionRange = vm.modals.moveQuestionModalParams.isModalOpen
    ? vm.getMoveQuestionAllowedRange(
        vm.modals.moveQuestionModalParams.groupIndex,
        vm.modals.moveQuestionModalParams.questionIndex,
      )
    : null;

  const SubmitButton = () => {
    const Btn = vm.planForm?.id ? EditButton : AddButton;
    const label = vm.planForm?.id ? 'Save changes' : 'Create inspection plan';

    return (
      <Btn
        type='button'
        // disabled={vm.state.loading}
        onClick={vm.doSaveInspectionPlan}
        data-testid='InspectionPlansForm.submit'
      >
        {label}
      </Btn>
    );
  };

  const {
    defectsModalParams,
    setDefectsModalParams,
    defectsModalData,
    defectsModalSelected,
    doToggleDefectSelect,
    doCreateDefect,
    questionGroupModalParams,
    setQuestionGroupModalParams,
    questionGroupModalData,
    questionsModalParams,
    setQuestionsModalParams,
    questionsModalData,
    questionsModalSelected,
    doToggleQuestionSelect,
    getQuestionsModalList,
    moveQuestionModalParams,
    doCloseMoveQuestionModal,
    resourcesModalParams,
    setResourcesModalParams,
    getInitialResourcesModalParams,
    resourcesModalData,
  } = vm.modals;

  return (
    <>
      <div className='inspection-plans-form'>
        {vm?.planForm?.errors?.length && (
          <ErrorBag errors={vm.planForm.errors} />
        )}
        <form noValidate>
          <InspectionPlansFormNewPlan vm={vm} />
          <InspectionPlansFormNewGroups vm={vm} />
          <SubmitButton />
        </form>
        {questionGroupModalParams.isModalOpen && (
          <QuestionGroupsModal
            data-testid='InspectionPlansForm.questionGroupsModal'
            data={questionGroupModalData.list}
            isOpen={questionGroupModalParams.isModalOpen}
            onRequestClose={() =>
              setQuestionGroupModalParams({
                ...questionGroupModalParams,
                isModalOpen: false,
              })
            }
            onRowClick={(qgt) => {
              vm.doAddQuestionGroup(qgt);
              setQuestionGroupModalParams({
                ...questionGroupModalParams,
                isModalOpen: false,
              });
            }}
            onSearchChange={(e) =>
              setQuestionGroupModalParams({
                ...questionGroupModalParams,
                search: e.target.value,
                page: 1,
              })
            }
            search={questionGroupModalParams.search}
            setSortBy={(col, order) =>
              setQuestionGroupModalParams({
                ...questionGroupModalParams,
                sortBy: col,
                sortOrder: order,
              })
            }
            sortBy={questionGroupModalParams.sortBy}
            sortOrder={questionGroupModalParams.sortOrder}
            setPage={(v) =>
              setQuestionGroupModalParams({
                ...questionGroupModalParams,
                page: v,
              })
            }
            page={questionGroupModalParams.page}
            pageSize={questionGroupModalParams.pageSize}
            count={questionGroupModalData.count}
          />
        )}
        {questionsModalParams.isModalOpen && (
          <QuestionsModal
            data-testid='InspectionPlansForm.questionsModal'
            data={getQuestionsModalList()}
            isOpen={questionsModalParams.isModalOpen}
            selectedCount={questionsModalSelected.length}
            onRequestClose={() =>
              setQuestionsModalParams({
                ...questionsModalParams,
                isModalOpen: false,
              })
            }
            onRowClick={(q) => doToggleQuestionSelect(q)}
            onSubmit={async () => {
              const isAssigned = await vm.doAssignQuestionsToGroup(
                questionsModalParams.groupIndex,
                questionsModalSelected,
              );
              if (isAssigned) {
                setQuestionsModalParams({
                  ...questionsModalParams,
                  isModalOpen: false,
                });
              }
            }}
            onAddCustomClick={async () => {
              const isAdded = await vm.doAddCustomQuestionToGroup(
                questionsModalParams.groupIndex,
              );
              if (isAdded) {
                setQuestionsModalParams({
                  ...questionsModalParams,
                  isModalOpen: false,
                });
              }
            }}
            onSearchChange={(e) =>
              setQuestionsModalParams({
                ...questionsModalParams,
                search: e.target.value,
                page: 1,
              })
            }
            search={questionsModalParams.search}
            setSortBy={(col, order) =>
              setQuestionsModalParams({
                ...questionsModalParams,
                sortBy: col,
                sortOrder: order,
              })
            }
            sortBy={questionsModalParams.sortBy}
            sortOrder={questionsModalParams.sortOrder}
            setPage={(v) =>
              setQuestionsModalParams({ ...questionsModalParams, page: v })
            }
            page={questionsModalParams.page}
            pageSize={questionsModalParams.pageSize}
            count={questionsModalData.count}
          />
        )}
        {moveQuestionModalParams.isModalOpen && (
          <MoveQuestionPositionModal
            isOpen={moveQuestionModalParams.isModalOpen}
            current={moveQuestionModalParams.questionIndex}
            min={moveQuestionRange.min}
            max={moveQuestionRange.max}
            onRequestClose={doCloseMoveQuestionModal}
            onSubmit={(targetIndex) => {
              doCloseMoveQuestionModal();
              vm.doMoveQuestionToPosition(
                moveQuestionModalParams.groupIndex,
                moveQuestionModalParams.questionIndex,
                targetIndex,
              );
            }}
          />
        )}
        {defectsModalParams.isModalOpen && (
          <DefectsModal
            data-testid='InspectionPlansForm.defectsModal'
            data={defectsModalData.list}
            count={defectsModalData.count}
            isCreatable
            onCreateClick={() => doCreateDefect()}
            isOpen={defectsModalParams.isModalOpen}
            onRequestClose={() =>
              setDefectsModalParams({
                ...defectsModalParams,
                isModalOpen: false,
              })
            }
            onRowClick={(v) => doToggleDefectSelect(v)}
            onSubmit={() => {
              vm.doSetDefectsList(
                defectsModalSelected,
                defectsModalParams.groupIndex,
                defectsModalParams.questionIndex,
              );
              setDefectsModalParams({
                ...defectsModalParams,
                isModalOpen: false,
              });
            }}
            onSearchChange={(e) =>
              setDefectsModalParams({
                ...defectsModalParams,
                search: e.target.value,
                page: 1,
              })
            }
            search={defectsModalParams.search}
            pageSize={defectsModalParams.pageSize}
            setPage={(v) =>
              setDefectsModalParams({ ...defectsModalParams, page: v })
            }
            page={defectsModalParams.page}
            setSortBy={(col, order) =>
              setDefectsModalParams({
                ...defectsModalParams,
                sortBy: col,
                sortOrder: order,
              })
            }
            sortBy={defectsModalParams.sortBy}
            sortOrder={defectsModalParams.sortOrder}
            errors={defectsModalData.errors}
          />
        )}
        {resourcesModalParams.isModalOpen && (
          <LinkableResourcesModal
            data-testid='InspectionPlansForm.linkableResourcesModal'
            data={resourcesModalData}
            isOpen={resourcesModalParams.isModalOpen}
            onRequestClose={() =>
              setResourcesModalParams({
                ...resourcesModalParams,
                isModalOpen: false,
              })
            }
            onRowClick={(resource) => {
              vm.doSetLinkedResource(resource);
              setResourcesModalParams({
                ...resourcesModalParams,
                isModalOpen: false,
              });
            }}
            onSearchChange={(e) =>
              setResourcesModalParams({
                ...resourcesModalParams,
                search: e.target.value,
                page: 1,
              })
            }
            search={resourcesModalParams.search}
            setSortBy={(col, order) =>
              setResourcesModalParams({
                ...resourcesModalParams,
                sortBy: col,
                sortOrder: order,
              })
            }
            setPage={(v) =>
              setResourcesModalParams({ ...resourcesModalParams, page: v })
            }
            page={resourcesModalParams.page}
            pageSize={resourcesModalParams.pageSize}
            sortBy={resourcesModalParams.sortBy}
            sortOrder={resourcesModalParams.sortOrder}
            onTabChange={(v) =>
              setResourcesModalParams({
                ...getInitialResourcesModalParams(),
                isModalOpen: true,
                tab: v,
              })
            }
            tab={resourcesModalParams.tab}
          />
        )}
      </div>
    </>
  );
};
export default InspectionPlansFormNew;
